import _createForOfIteratorHelper from "C:/Users/RedFlag/Desktop/code/qms/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
export default {
  props: {
    tableData: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    defectTypesClass: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    defectsList: {
      default: function _default() {
        return [];
      },
      type: Array
    }
  },
  data: function data() {
    return {
      state: 0,
      isPut: false
    };
  },
  watch: {
    tableData: function tableData(val) {
      if (val.length !== 0) {
        this.isPut = true;

        var _iterator = _createForOfIteratorHelper(val),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.defectTypes.defect !== "") {
              this.changeSelet(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  },
  methods: {
    addDefects: function addDefects() {
      var row = {
        defectTypes: {
          defect: "",
          data: this.defectTypesClass
        },
        defectLocation: {
          place: "",
          data: []
        },
        note: ""
      };
      this.tableData.push(row);
    },
    focusSelet: function focusSelet(SeleteItem) {
      this.isPut = false;
    },
    blurSelet: function blurSelet(Item) {// Item.defectLocation.place = "";
    },
    changeSelet: function changeSelet(item) {
      var defect = item.defectTypes.defect.name ? item.defectTypes.defect.name : item.defectTypes.defect;
      var arr = [];

      var _iterator2 = _createForOfIteratorHelper(this.defectsList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var defaultItem = _step2.value;

          if (defaultItem.defectType === defect) {
            var obj = {};
            obj.id = defaultItem.id;
            obj.name = defaultItem.place;
            arr.push(obj);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      item.defectLocation.data = arr;

      if (!this.isPut) {
        item.defectLocation.place = "";
      }
    },
    deleteDefect: function deleteDefect(row, index) {
      this.tableData.splice(index, 1);
    }
  }
};